// Import Libraries
import React, { useEffect, useState, useContext } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Stack,
  Button,
  TextField,
  Collapse,
  Alert,
  Box,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Services
import userService from '../../services/userService';

// Context
import { UserContext } from '../../context/User';

const UserDetails = ({ userDetails = {} }) => {
  const { user, setUpdateUser } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [showSaved, setShowSaved] = useState(false);
  const [userData, setUserData] = useState({
    first_name: userDetails.first_name || '',
    last_name: userDetails.last_name || '',
  });

  const updateUser = async () => {
    try {
      const payload = { ...userData, id: userDetails.id };
      const userUpdate = await userService.updateProfileFields(payload);

      if (user?.id === userDetails.id) setUpdateUser('basic');

      if (userUpdate) {
        setShowSaved(true);
        setTimeout(() => setShowSaved(false), 2000);
      }
    } catch (err) {
      setError(err?.message || 'Unable to save profile.');
    }
  };

  useEffect(() => {
    if (userDetails?.id) {
      setUserData({
        first_name: userDetails.first_name || '',
        last_name: userDetails.last_name || '',
      });
    }
  }, [userDetails]);

  return (
    <Card sx={{ minWidth: 300 }}>
      <CardHeader
        title="User Details"
        action={
          <Stack direction="row" spacing={1} alignItems="center">
            <Collapse in={showSaved} orientation="horizontal">
              <Box sx={{ display: 'flex', alignItems: 'center', color: 'success.main' }}>
                <CheckCircleIcon />
              </Box>
            </Collapse>
            <Button onClick={updateUser}>Save</Button>
          </Stack>
        }
        sx={{ pb: 0 }}
      />

      <CardContent>
        <Stack spacing={2}>
          <TextField
            fullWidth
            label="First Name"
            name="first_name"
            value={userData.first_name}
            onChange={(e) => setUserData((p) => ({ ...p, first_name: e.target.value }))}
          />

          <TextField
            fullWidth
            label="Last Name"
            name="last_name"
            value={userData.last_name}
            onChange={(e) => setUserData((p) => ({ ...p, last_name: e.target.value }))}
          />

          {/* Email: disabled so it cannot be focused/clicked */}
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={userDetails.email || ''}
            disabled
            sx={(theme) => ({
              // Subtle gray look for disabled/read-only feel
              '& .MuiOutlinedInput-root': {
                bgcolor: theme.palette.action.hover,
              },
              // Make disabled text readable (MUI dims it by default)
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: theme.palette.text.secondary,
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: theme.palette.text.secondary,
              },
            })}
          />

          <Collapse in={!!error}>
            <Alert severity="error" onClose={() => setError(null)}>
              {error}
            </Alert>
          </Collapse>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default UserDetails;
